import { getAlarmSettings } from './getAlarmSettings';
import { getPocList } from './getPocList';
import { deletePoc } from './deletePoc';
import { registerPoc } from './registerPoc';

export const myPageService = {
  getAlarmSettings: getAlarmSettings,
  getPocList: getPocList,
  deletePoc: deletePoc,
  registerPoc: registerPoc,
};
